module.exports = __webpack_public_path__ + "img/avatar_ico13.a1f97c80.jpg";